module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "bannerContent",
    staticClass: "bannerContent",
    domProps: {
      "innerHTML": _vm._s(_vm.bannerContentFn)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-459548bf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/bannerContent.vue
// module id = 530
// module chunks = 0